<template>
  <Layout>
    <template v-slot:search-header>
      <div
        class="search_result"
        :class="[
          {
            border_none: true,
          },
          linksAddClass,
        ]"
      >
        <div class="top_btn">
          <p>
            <span class="icon"><img src="@img/icon_72_genre.png"/></span>
            <span class="text">{{searchTagName}}</span>
          </p>
          <a href="javascript:void(0);" class="btn" @click="clearToTop">
              <span class="icon"><img src="@img/icon_72_top.png"/></span>
              <span>検索TOP</span>
          </a>
        </div>
      </div>

      <div v-show="0 === tabList.length && afterInit" :class="linksTabClass">
        <div class="hit_result">
          <div class="result_num"
            ><span class="subject">ヒット件数 0件</span>
          </div>
        </div>
      </div>
      <div v-show="0 < tabList.length && afterInit"  :class="linksTabClass">
        <div id="slide_area">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div
                v-for="(tab, index) in tabList"
                :key="index"
                class="swiper-slide"
              >
                <div
                  class="one_tab"
                  :class="{ selected: selectedIndex === index }"
                  @click="tabSelected(index)"
                >
                  <p>
                    <span class="sp">{{ tab.TAB_NAME }}</span>
                    <span class="pc">{{ tab.TAB_NAME }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-show="!isMobile && afterInit" class="swiper-button-prev"
            ><img src="@img/arrow_L.png"
          /></div>
          <div v-show="!isMobile && afterInit" class="swiper-button-next"
            ><img src="@img/arrow_R.png"
          /></div>
        </div>
        <div class="tab_bottom_line" :class="[tabLine, tabList.length > 0 ? '' : 'noTabList']"></div>
      </div>
    </template>
    <div id="all_wrapper" class="height100">
      <div id="app">
        <div
          id="su07_contents"
          class="content_limit_cover height100"
          :class="linksAddClass"
        >
          <transition class="modal">
            <div
              v-if="groupModalWindowFlg"
              id="group_popup"
              @click="groupModalClose"
            >
              <div class="modal_set" @click="stopEvent">
                <div class="modal_contents">
                  <div class="modal_head">
                    <div
                      v-if="selectedShop && selectedShop.FC_NAME"
                      class="head_name"
                      >{{ selectedShop.FC_NAME }}</div
                    >
                    <!-- head部分を読み込んだ判定でポップアップサイズを指定したいため、下記閉じるボタン読み込みに:loadを指定 -->
                    <button class="modal_close" @click="groupModalClose"
                      ><img src="@img/icon_72_close.png" @load="modalHeightSet"
                    /></button>
                  </div>
                  <div class="modal_inner">
                    <div
                      v-if="selectedShop && selectedShop.shop"
                      class="shop_list"
                    >
                      <div
                        v-for="(shop, s_index) in selectedShop.shop"
                        :key="s_index"
                        class="one_set"
                      >
                        <a
                          href="javascript:void(0);"
                          class="modal_a_link_c"
                          @click="
                            saveSessAndToDetail(
                              shop.FACILITIES_ID || shop.SHISETU_ID,
                              shop.MENBER_ONLY_FLAG,
                            )
                          "
                        >
                          <h4>{{ shop.MEISYO || shop.NAME }}</h4>
                          <div class="content_inner">
                            <div class="photo_area"
                              ><div><img :src="combineUrl(shop.PHOTO1)"/></div
                            ></div>
                            <div class="sentence_area">
                              <p
                                v-if="shop.TOKUBETU_FLAG == 1 || shop.COUPON == 1"
                                v-show="shop.WB_NAIYO1"
                                class="service_toku"
                                ><span><img src="@img/icon_48_en.png"/></span>
                                <span>{{ discount(shop) }}</span></p
                              >
                              <p v-else v-show="shop.WB_NAIYO1" class="service"
                                ><span><img src="@img/icon_48_en.png"/></span
                                ><span>{{ discount(shop) }}</span></p
                              >
                              <div
                                v-if="shop.PREMIAM_FLAG == 1 && !shop.WB_NAIYO1 && !shop.TOKUBETU_NAIYOU && shop.COUPON != 1"
                                class="only_premiam"
                              >
                                <p class="distance">
                                  <span class="icon"><img class="toku" src="@img/period_premium.png"/></span>
                                  <span class="tokubetu">プレミアム優待</span>
                                </p>
                                <p class="naiyou" >
                                  <span>10年以上ご継続いただいている個人会員の方限定の優待実施中です。</span>
                                </p>
                              </div>
                              <div
                                v-else-if="shop.COUPON == 1">
                                <p
                                  class="distance"
                                  ><span class="icon"
                                    ><img class="ap_cou" src="@img/icon_cassette_coupon.png"
                                  /></span>
                                  <span class="ap_coupon"
                                    >アプリクーポン</span
                                  ></p
                                >
                                <p v-if="showCouponLogin"
                                  class="coupon_naiyou"
                                  ><span>ログインのうえご確認ください。ご利用にはJAFアプリのインストールが必要です。</span
                                ></p>
                                <p v-else-if="shop.COUPON_SUMMARY"
                                  class="coupon_naiyou"
                                  ><span v-html="shop.COUPON_SUMMARY.replace(/(\\r)*\\n/g, '<br>')"></span
                                ></p>
                              </div>
                              <div
                                v-else-if="shop.TOKUBETU_FLAG == 1 && shop.COUPON != 1">
                                <p
                                  class="distance"
                                  ><span class="icon"
                                    ><img class="toku" src="@img/period.png"
                                  /></span>
                                  <span class="tokubetu">特別優待</span></p
                                >
                                <p class="naiyou"
                                  ><span v-html="shop.TOKUBETU_NAIYOU.replace(/(\\r)*\\n/g, '<br>')"></span
                                ></p>
                              </div>
                            </div>
                          </div>
                          <div class="tag_list">
                            <p v-if="shop.COUPON == 1" class="one_tag tag_app"
                              ><span>アプリクーポン</span></p
                            >
                            <p
                              v-if="shop.TOKUBETU_FLAG == 1"
                              class="one_tag tag_limited"
                              ><span>特別優待</span></p
                            >
                            <p
                              v-if="shop.WEB_FLAG == 1"
                              class="one_tag tag_online"
                              ><span>オンライン優待</span></p
                            >
                            <p
                              v-if="shop.PREMIAM_FLAG == 1"
                              class="one_tag tag_premium"
                              ><span>プレミアム優待</span></p
                            >
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
          <div class="header_banner" :class="linksAddClass"> </div>

          <div class="area_type">
          </div>

          <div
            class="list-swiper-container"
            :class="[linksAddClass, tabList.length > 0 ? '' : 'noTabList']"
          >
            <div class="swiper-wrapper">
              <div
                v-for="(tab, index) in tabList"
                :key="index"
                :class="['swiper-slide','list-swiper-slide']"
                @scroll.passive="onScroll"
              >
                <div class="hit_result">
                  <div class="result_num"
                    ><span class="subject">ヒット件数 {{ tabCount(index) }}件</span>
                  </div>
                  <div class="hit_right">
                    <div class="sub_select">
                      <select
                        v-model="subSelect"
                        :class="{ selected_on: true }"
                        :disabled="getSubList(selectedIndex).length <= 1"
                      >
                        <option :value="0" class="no_select">{{
                          subAllText
                        }}</option>
                        <option
                          v-for="(sub, index) in getSubList(selectedIndex)"
                          :key="index"
                          :value="sub.code"
                          >{{ sub.name }}</option
                        >
                      </select>
                    </div>
                  </div>
                </div>

                <!-- ショップ検索結果（vue.jsによるシステムループ -->
                <ul
                  v-if="shouldShowTabList(index)"
                  id="shop_info"
                  :ref="`shop_info_${index}`"
                  class="shop_info"
                >
                  <li
                    v-for="(item, itemIndex) in partTabSearchResult(index)"
                    :key="itemIndex"
                    :class="{
                      multi: Object.keys(item.shop).length > 1,
                      hide: !isShowOnlineItem(item),
                    }"
                  >
                    <!-- 「multi」クラスの有無で、単一店舗or複数店舗の表示をcss制御しています -->
                    <!-- 該当店舗が１つだけの時に表示される情報 -->
                    <div class="type_single">
                      <a
                        href="javascript:void(0);"
                        @click="
                          saveSessAndToDetail(
                            item.shop[0].FACILITIES_ID || item.shop[0].SHISETU_ID,
                            item.shop[0].MENBER_ONLY_FLAG,
                          )
                        "
                      >
                        <h4>{{ item.shop[0].MEISYO || item.shop[0].NAME }}</h4>
                        <div class="content_inner">
                          <div class="photo_area"
                            ><div
                              ><img
                                :src="combineUrl(item.shop[0].PHOTO1)"
                                :onerror="defaultAvatar"
                                loading="lazy"/></div
                          ></div>
                          <div class="sentence_area">
                            <p
                              v-if="item.shop[0].TOKUBETU_FLAG == 1 || item.shop[0].COUPON == 1"
                              v-show="item.shop[0].WB_NAIYO1"
                              class="service_toku"
                              ><span><img src="@img/icon_48_en.png"/></span>
                              <span>{{ discount(item.shop[0]) }}</span></p
                            >
                            <p
                              v-else
                              v-show="item.shop[0].WB_NAIYO1"
                              class="service"
                              ><span><img src="@img/icon_48_en.png"/></span
                              ><span>{{ discount(item.shop[0]) }}</span></p
                            >
                            <div
                              v-if="item.shop[0].PREMIAM_FLAG == 1 && !item.shop[0].WB_NAIYO1 && !item.shop[0].TOKUBETU_NAIYOU && item.shop[0].COUPON != 1"
                              class="only_premiam"
                            >
                              <p class="distance">
                                <span class="icon"><img class="toku" src="@img/period_premium.png"/></span>
                                <span class="tokubetu">プレミアム優待</span>
                              </p>
                              <p class="naiyou" >
                                <span>10年以上ご継続いただいている個人会員の方限定の優待実施中です。</span>
                              </p>
                            </div>
                             <div
                              v-else-if="item.shop[0].COUPON == 1">
                              <p
                                class="distance"
                                ><span class="icon"
                                  ><img class="ap_cou" src="@img/icon_cassette_coupon.png"
                                /></span>
                                <span class="ap_coupon"
                                  >アプリクーポン</span
                                ></p
                              >
                              <p v-if="showCouponLogin"
                                class="coupon_naiyou"
                                ><span>ログインのうえご確認ください。ご利用にはJAFアプリのインストールが必要です。</span
                              ></p>
                              <p v-else-if="item.shop[0].COUPON_SUMMARY"
                                class="coupon_naiyou"
                                ><span v-html="item.shop[0].COUPON_SUMMARY.replace(/(\\r)*\\n/g, '<br>')"></span
                              ></p>
                            </div>
                            <div
                              v-else-if="item.shop[0].TOKUBETU_FLAG == 1 && item.shop[0].COUPON != 1">
                              <p
                                class="distance"
                                ><span class="icon"
                                  ><img class="toku" src="@img/period.png"
                                /></span>
                                <span class="tokubetu">特別優待</span></p
                              >
                              <p
                                class="naiyou"
                                ><span
                                  v-html="item.shop[0].TOKUBETU_NAIYOU.replace(/(\\r)*\\n/g, '<br>')"
                                ></span
                              ></p>
                            </div>
                          </div>
                        </div>
                        <div class="tag_list">
                          <p
                            v-if="item.shop[0].COUPON == 1"
                            class="one_tag tag_app"
                            ><span>アプリクーポン</span></p
                          >
                          <p
                            v-if="item.shop[0].TOKUBETU_FLAG == 1"
                            class="one_tag tag_limited"
                            ><span>特別優待</span></p
                          >
                          <p
                            v-if="item.shop[0].WEB_FLAG == 1"
                            class="one_tag tag_online"
                            ><span>オンライン優待</span></p
                          >
                          <p
                            v-if="item.shop[0].PREMIAM_FLAG == 1"
                            class="one_tag tag_premium"
                            ><span>プレミアム優待</span></p
                          >
                        </div>
                      </a>
                    </div>
                    <!-- 該当店舗が１つだけの時に表示される情報 ここまで -->

                    <!-- 該当店舗が複数ある時に表示される情報 -->
                    <div class="type_multi">
                      <div class="content_inner">
                        <div class="photo_area"
                          ><div
                            ><img
                              :src="item.FC_IMAGE ? item.FC_IMAGE : noImg"
                              :onerror="defaultAvatar"
                              loading="lazy"/></div
                        ></div>
                        <div class="sentence_area">
                          <p v-if="item && item.FC_NAME" class="shop_name">{{
                            item.FC_NAME
                          }}</p>
                          <p v-if="item && item.shop" class="shop_count"
                            >店舗数<span>
                              {{ Object.keys(item.shop).length }}</span
                            >件</p
                          >
                        </div>
                      </div>
                      <div
                        class="shop_detail accordion"
                        :class="{ on: item.accordion }"
                      >
                        <!-- 「on」クラスの有無で、アコーディオンのスイッチ及び中身の表示をcss制御しています -->
                        <div
                          class="switch inner"
                          @click="accordionSwitch(item, itemIndex)"
                        >
                          <div
                            ><p
                              ><span>店舗を見る</span
                              ><span
                                ><img
                                  src="@img/arrow_simple_32_D_navy.png"/></span></p
                          ></div>
                          <div
                            ><p
                              ><span
                                ><img
                                  src="@img/arrow_simple_32_U_navy.png"/></span
                              ><span>閉じる</span></p
                            ></div
                          >
                        </div>

                        <div
                          :id="'contents_accrdion_' + index + '_' + itemIndex"
                          class="contents"
                        >
                          <!-- ショップ詳細（アコーディオン内。vue.jsによるシステムループ） -->
                          <div class="shop_detail">
                            <div
                              v-for="(shop, index) in item.shop"
                              :key="index"
                              class="one_set"
                            >
                              <a
                                href="javascript:void(0);"
                                @click="
                                  saveSessAndToDetail(
                                    shop.FACILITIES_ID || shop.SHISETU_ID,
                                    shop.MENBER_ONLY_FLAG,
                                  )
                                "
                              >
                                <h4>{{ shop.MEISYO || shop.NAME }}</h4>
                                <div class="content_inner">
                                  <div class="photo_area"
                                    ><div
                                      ><img
                                        :src="combineUrl(shop.PHOTO1)"/></div
                                  ></div>
                                  <div class="sentence_area">
                                    <p
                                      v-if="shop.TOKUBETU_FLAG == 1 || shop.COUPON == 1"
                                      v-show="shop.WB_NAIYO1"
                                      class="service_toku"
                                      ><span
                                        ><img src="@img/icon_48_en.png"
                                      /></span>
                                      <span>{{ discount(shop) }}</span></p
                                    >
                                    <p
                                      v-else
                                      v-show="shop.WB_NAIYO1"
                                      class="service"
                                      ><span
                                        ><img src="@img/icon_48_en.png"/></span
                                      ><span>{{ discount(shop) }}</span></p
                                    >
                                    <div
                                      v-if="shop.PREMIAM_FLAG == 1 && !shop.WB_NAIYO1 && !shop.TOKUBETU_NAIYOU && shop.COUPON != 1"
                                      class="only_premiam"
                                    >
                                      <p class="distance">
                                        <span class="icon"><img class="toku" src="@img/period_premium.png"/></span>
                                        <span class="tokubetu">プレミアム優待</span>
                                      </p>
                                      <p class="naiyou" >
                                        <span>10年以上ご継続いただいている個人会員の方限定の優待実施中です。</span>
                                      </p>
                                    </div>
                                    <div
                                      v-else-if="shop.COUPON == 1">
                                      <p
                                        class="distance"
                                        ><span class="icon"
                                          ><img class="ap_cou" src="@img/icon_cassette_coupon.png"
                                        /></span>
                                        <span class="ap_coupon"
                                          >アプリクーポン</span
                                        ></p
                                      >
                                      <p v-if="showCouponLogin"
                                        class="coupon_naiyou"
                                        ><span>ログインのうえご確認ください。ご利用にはJAFアプリのインストールが必要です。</span
                                      ></p>
                                      <p v-else-if="shop.COUPON_SUMMARY"
                                        class="coupon_naiyou"
                                        ><span v-html="shop.COUPON_SUMMARY.replace(/(\\r)*\\n/g, '<br>')"></span
                                      ></p>
                                    </div>
                                    <div
                                      v-else-if="shop.TOKUBETU_FLAG == 1 && shop.COUPON != 1">
                                      <p
                                        class="distance"
                                        ><span class="icon"
                                          ><img
                                            class="toku"
                                            src="@img/period.png"
                                        /></span>
                                        <span class="tokubetu"
                                          >特別優待</span
                                        ></p
                                      >
                                      <p
                                        class="naiyou"
                                        ><span
                                          v-html="shop.TOKUBETU_NAIYOU.replace(/(\\r)*\\n/g, '<br>')"
                                        ></span
                                      ></p>
                                    </div>
                                  </div>
                                </div>
                                <div class="tag_list in_accordion">
                                  <p
                                    v-if="shop.COUPON == 1"
                                    class="one_tag tag_app"
                                    ><span>アプリクーポン</span></p
                                  >
                                  <p
                                    v-if="shop.TOKUBETU_FLAG == 1"
                                    class="one_tag tag_limited"
                                    ><span>特別優待</span></p
                                  >
                                  <p
                                    v-if="shop.WEB_FLAG == 1"
                                    class="one_tag tag_online"
                                    ><span>オンライン優待</span></p
                                  >
                                  <p
                                    v-if="shop.PREMIAM_FLAG == 1"
                                    class="one_tag tag_premium"
                                    ><span>プレミアム優待</span></p
                                  >
                                </div>
                              </a>
                            </div>
                          </div>
                          <!-- ショップ詳細 ここまで -->
                          <div
                            class="switch inner"
                            @click="accordionSwitch(item, itemIndex)"
                          >
                            <div
                              ><p
                                ><span>店舗を見る</span
                                ><span
                                  ><img
                                    src="@img/arrow_simple_32_D_navy.png"/></span></p
                            ></div>
                            <div
                              ><p
                                ><span
                                  ><img
                                    src="@img/arrow_simple_32_U_navy.png"/></span
                                ><span>閉じる</span></p
                              ></div
                            >
                          </div>
                        </div>
                      </div>
                      <div
                        class="shop_detail_pc modal"
                        :class="{ on: item.accordion }"
                      >
                        <div @click="pcModalOpen(item, itemIndex)">
                          <div
                            ><p><span>店舗を見る</span></p></div
                          >
                        </div>
                      </div>
                    </div>
                    <!-- 該当店舗が複数ある時に表示される情報 ここまで -->
                  </li>
                </ul>
                <!-- ショップ検索結果（vue.jsによるシステムループ）ここまで -->
                <div
                  v-show="index == selectedIndex && afterInit"
                  v-else
                  class="no-result-data no-result-data-tab"
                >
                  検索条件に該当する優待施設はありません。
                </div>
                <Footer
                  v-if="isMobile"
                  v-show="index == selectedIndex && afterInit"
                />
              </div>
            </div>

            <div
              v-if="tabList.length === 0"
              :class="['swiper-slide','list-swiper-slide','noTabList']"
              @scroll.passive="onScroll">
            </div>
            <div
              v-show="tabList.length === 0 && afterInit"
              class="no-result-data no-result-data-tab"
              >
              検索条件に該当する優待施設はありません。
            </div>
            <Footer
              v-if="isMobile"
              v-show="tabList.length === 0 && afterInit"
            />

          </div>
					<form id="ssnIdPostForm" name="ssnIdForm" action="" method="POST" target="_blank"></form>
        </div>
      </div>
    </div>
    <Footer v-if="!isMobile" v-show="afterInit && !isInTransition" />
  </Layout>
</template>

<script>
import Layout from '@layouts/main.vue'
import Footer from '@components/footer.vue'
import locationIcon from '@img/icon_48_pin.png'
import couponIcon from '@img/icon_48_en.png'
import downIcon from '@img/arrow_simple_32_D_navy.png'
import upIcon from '@img/arrow_simple_32_U_navy.png'
import noImg from '@img/map/noimage.png'
import withCouponIcon from '@img/icon_with_coupon.png'
import {
  setSessionItem,
  removeSessionItem,
  clearSessionSearch,
} from '@utils/session.js'
import {
  API_SHOP_LIST_FC,
  API_SHOP_LIST,
  API_TAB_SHOP_LIST,
  API_SEARCH_TAG_SHOP_LIST,
} from '@utils/api.js'
import {
  prefectures,
  genreMainText,
  genreSubText,
  genreIndex,
  subGenreList,
  areaText,
  areaCode,
  prefectureText,
  getMunicipalityFromAreaCode,
  areas,
  genre,
  areaIndex,
  subPrefectureList,
  subPrefectureListByCode,
  subGenreListByCode,
  DISPLAYMODE,
  isConditionEmpty,
  toMapWithQuery,
} from '@state/modules/facility-search.js'
import { watchPosition } from '@utils/geoLocation.js'
import popupGuest from '@utils/popup-guest.js'
import popup from '@utils/popup.js'
import * as Swiper from '@/node_modules/swiper/swiper-bundle.min.js'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'SearchResult',
  metaInfo() {
    return {
      title: this.pageTitle,
      meta: [{ name: 'description', content: this.pageTitle }],
    }
  },
  components: { Layout, Footer },
  data() {
    return {
      searchTagId: '',
      searchTagName: '',
      pGenre: '',
      locationIcon,
      couponIcon,
      downIcon,
      upIcon,
      noImg,
      withCouponIcon,
      searchResult: {},
      afterInit: false,
      count: 0,
      isBack: false,
      SORT_NAME: '1',
      SORT_DIST: '2',
      searchSort: '1',
      couponNo: null,
      isSentGA: false,

      isInTransition: false,

      genreList: this.$store.state.genre.mainGenre.slice(1),

      selectedIndex: 0,
      selectedShop: null,
      tempSelectedShop: null,
      // 現在選択中のサブジャンルは何か
      searchSub: '',
      // 詳細ショップ（PC）モーダル情報// 詳細ショップ（PC）モーダル情報（0]グループID, [1]店舗名, [2]サムネイル画像, [3]距離, [4]サービス内容 , [5]タグセット配列）※oneSlectItemから流用するために[id]を残しているが表示的には不要なデータになります。
      oneSlectModalItem: [],
      // タブ表示リスト（タブID：,[0]タブ名,[1]PCの際の名前(改行のため),[2]検索時利用するタグ名の想定,[3]選択中かどうか）
      // 都道府県/サブジャンルの選択状態(ID)
      subSelect: '0',
      // キーワード検索用のソートタブ
      sort: 1,
      // ソート用変数
      sortKey: '',

      tabs: [],
      tabResultData: {},

      // PCモーダル表示(店舗詳細から戻った際は、ここをtrue,oneSlectModalItemの変数に該当の店舗リストを入れてください)
      groupModalWindowFlg: false,
      // モーダルの名前
      groupName: '',
      tabSwiper: null,
      listSwiper: null,
      showCount: 10,
      showCouponLogin: this.$store.state.auth && this.$store.state.auth.userType &&
      !(this.$store.state.auth.userType === '0'||this.$store.state.auth.userType === '1'||this.$store.state.auth.userType === '2'||this.$store.state.auth.userType === '3'||this.$store.state.auth.userType === '4'||this.$store.state.auth.userType === '80'),
    }
  },
  computed: {
    pageTitle() {
      var searchTagName = this.searchTagName;

      if(!searchTagName)
      {
        searchTagName = '検索タグ別優待施設'
      }

      return `${searchTagName} | JAFナビ`
    },
    defaultAvatar() {
      return 'this.src ="' + noImg + '"'
    },
    tabList() {
      return this.tabs
    },
    genreMainText() {
      return genreMainText(this.genreCode)
    },
    genreSubText() {
      return genreSubText(this.genreCode)
    },
    subAllText() {
      return 'すべて'
    },
    genreCode: {
      get() {
        return this.$store.state.facilitySearch.genreCode
      },
      set(value) {
        this.$store.dispatch('facilitySearch/setGenreCode', value)
        setSessionItem('GENRE', value)
        setSessionItem('SHOP_MAIN_GENRE', genreMainText(value))
        setSessionItem('SHOP_SUB_GENRE', genreSubText(value))
        this.requestData()
      },
    },
    areaCode: {
      get() {
        return this.$store.state.facilitySearch.areaCode
      },
      set(value) {
        this.$store.dispatch('facilitySearch/setAreaCode', value)
        setSessionItem('AREA', value)
        this.requestData()
      },
    },
    areaText() {
      if (this.areaCode.length == 3) {
        return areaText(this.areaCode)
      } else {
        return areaText(this.areaCode.split(/(\s+)/)[2])
      }
    },
		prefectureText() {
      if (this.areaCode.length == 3) {
        return 'すべて'
      } else {
        return prefectureText(this.areaCode.split(/(\s+)/)[2])
      }
    },
		municipalityText() {
			const munText = getMunicipalityFromAreaCode(this.areaCode)
      if (munText == '全域') {
        return 'すべて'
      } else {
        return munText
      }
    },
    tabLine() {
      let color_index = this.selectedIndex + 1
      if (color_index > 12) {
        color_index = Math.floor(color_index % 12)
      }
      return 'selected_color_' + color_index
    },
    searchText() {
      const conditions = []
      if (this.genreCode) {
        if (!this.isMainOnlyGenre) {
          conditions.push([this.genreMainText, ' ' + this.genreSubText])
        } else {
          conditions.push([this.genreMainText])
        }
      }
			if (this.areaCode) {
        if (this.municipalityText) {
          conditions.push([
            this.areaText,
            ' ' + this.prefectureText + ' ' + this.municipalityText
          ])
        } else {
          conditions.push([this.areaText, ' ' + this.prefectureText])
        }
      }
      let conditionsString = ''
      for (var i = 0; i < conditions.length; i++) {
        if (conditions[i][0]) {
          conditionsString += conditions[i][0]
        }
        if (conditions[i][1]) {
          conditionsString += conditions[i][1]
        }
        if (i < conditions.length - 1) {
          conditionsString += ','
        }
      }
      return conditionsString
    },
    isMobile() {
      return window.innerWidth < 768
    },
    isMainOnlyGenre() {
      const genreText = genreMainText(this.genreCode)
      if (
        genreText != '温泉・入浴施設' &&
        genreText != '道の駅' &&
        genreText != 'SA・PA（サービスエリア）'
      ) {
        return false
      } else {
        return true
      }
    },
    shouldShowOnlineShop() {
      if (
        (this.areaCode && this.areaCode != '')
      ) {
        return false
      } else {
        return true
      }
    },
    partSearchResult() {
      const result = {}
      let key

      for (key in this.searchResult) {
        if (this.searchResult.hasOwnProperty(key) && key < this.showCount) {
          result[key] = this.searchResult[key]
        }
      }

      return result
    },
    toMapCss() {
      if (this.count == 0) {
        return 'button disabled'
      } else {
        return 'button'
      }
    },
    loginUrl() {
      const url = `${process.env.VUE_APP_SSO_URL}?qServiceId=${
        process.env.VUE_APP_SSO_ID
      }&qUrl=${encodeURIComponent(decodeURI(location.href))}`
      return url
    },
    isLinksMode() {
      if (
        this.$store.state.auth.userType == '80' &&
        this.$store.state.auth.loggedIn
      ) {
        return true
      }

      return false
    },
    linksTabClass() {
      if (this.isLinksMode) {
        return 'tab_set_none_header'
      } else {
        return 'tab_set'
      }
    },
    linksAddClass() {
      if (this.isLinksMode) {
        return 'none_header'
      } else {
        return ''
      }
    },
    ...mapState({
      searchWord: (state) => state.facilitySearch.searchWord,
      existCoupon: (state) => state.facilitySearch.existCoupon,
      isOnline: (state) => state.facilitySearch.isOnline,
      isPremiam: (state) => state.facilitySearch.isPremiam,
      isNewShop: (state) => state.facilitySearch.isNewShop,
    }),
  },
  watch: {
    subSelect: function(val) {
      if (val === 0) {
        this.resetSubData()
      } else {
        this.requestDataBySub(val)
      }
    },
    immediate: true,
    deep: true,
    $route(to, from) {
      this.isBack = false

      if (to.name === 'searchTag-facility' && from.name === 'facility-detail') {
        this.isBack = true
      }

      if (
        to.name === 'searchTag-facility' &&
        from.name === 'facility-search' &&
        from.meta.isBack
      ) {
        this.isBack = true
      }
    },
  },
  created() {
    this.afterInit = false
  },
  activated() {
    // get id of searchTag
    this.searchTagId = this.$route.params.id
    if (!this.searchTagId) {
      window.location.replace('https://jafnavi.jp')
      return
    }
    this.pGenre = this.$route.params.genre;
    // for back from facility detail
    this.$store.dispatch('facilitySearch/setSearchTagId', this.searchTagId)

    this.isSentGA = false
    if (!this.afterInit || !this.isBack) {
      this.init()
    } else {
      if (!this.isMobile) {
        this.$nextTick(() => {
          window.scrollTo(0, this.$store.state.searchResult.scrollTop)

          if (this.tempSelectedShop) {
            this.pcModalOpen(this.tempSelectedShop, 0)
          }
        })
      } else {
        const items = this.tabSearchResult(this.selectedIndex)

        for (const index in items) {
          if (items[index].accordion == true) {
            this.openAccordion(index)
          }
        }

        const scrollEls = document.getElementsByClassName('list-swiper-slide')
        scrollEls[this.selectedIndex].scrollTop =
          scrollEls[this.selectedIndex] &&
          this.$store.state.searchResult.scrollTop
      }
      var scrollMaps = this.$store.state.searchResult.fcScrollTopMap
      for (var i in scrollMaps) {
        this.$refs[i][0].scrollTop = scrollMaps[i]
      }
    }

    this.$nextTick(function() {
      window.addEventListener('scroll', this.onScroll)
    })

  },
  deactivated() {
    window.removeEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    const shops = {
      COUNT: this.count,
      fc: this.searchResult,
    }
    setSessionItem('SHOP', JSON.stringify(shops))
    setSessionItem('TYPE', '1')
  },
  methods: {
    init() {
      if (this.listSwiper) {
        this.listSwiper.destroy()
        this.listSwiper = null
      }
      if (this.tabSwiper) {
        this.tabSwiper.destroy()
        this.tabSwiper = null
      }
      this.initTabIndex()
      var shopData = sessionStorage.getItem('SHOP')
      this.couponNo = sessionStorage.getItem('COUPON_NO')
      this.searchSort = sessionStorage.getItem('SORT')
      this.requestTabData()
    },
    requestTabData() {
      this.$store.dispatch('layout/startLoading')
      this.searchResult = []
      this.tabs = []
      this.afterInit = false
      this.count = 0
      var params = {}
      var that = this
      params.session_id = this.$store.state.auth.sessionId
   // params.LIMIT = 300
      params.SEARCH_TAG_ID = this.searchTagId
   // params.AREA = ""
      params.GENRE = this.pGenre

      var formData = new FormData();
      for (var k in params) {
        formData.append(k, params[k] ?? "");
      }

      this.$.post(API_SEARCH_TAG_SHOP_LIST, formData)
        .then((response) => {
          if (response.data.shop && response.data.shop[0]) {
            const result = response.data
              that.$store.dispatch('layout/endLoading')

            this.tabs = Object.keys(response.data.shop).map((key) => {
              var tabData = response.data.shop[key]
              var tab = {}
              tab.TAB_ID = tabData.TAB_ID
              tab.TAB_NAME = tabData.TAB_NAME
              tab.TYPE = tabData.TYPE
              tab.COUNT = tabData.COUNT
              return tab
            })
            for (var i in result.shop) {
              for (var j in result.shop[i].fc) {
                result.shop[i].fc[j].on = false
                result.shop[i].fc[j].accordion = false
              }
            }
            this.searchResult = result.shop[0].fc
            this.count = result.shop[0].COUNT
            this.tabResultData = result
          } else {
            this.searchResult = {}
            this.count = 0
            this.tabResultData = response.data
          }

          this.searchTagId   = response.data.SEARCH_TAG_ID
          this.searchTagName = response.data.SEARCH_TAG_NAME
          this.afterInit = true

          if (!this.isSentGA) {
                window.dataLayer.push({
                event: 'Webview',
                ap_screen_name: 'JAFナビ_検索タグ施設一覧',
              })

            this.isSentGA = true
          }
          this.$store.dispatch('layout/endLoading')

          this.$nextTick(() => {
            this.tabSwiper = new Swiper('.swiper-container', {
              loop: false,
              slidesPerView: 'auto',
              centeredSlides: false,
              initialSlide: 0,
              observer: true,
              observeParents: true,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            })

            if (this.isMobile) {
              this.listSwiper = new Swiper('.list-swiper-container', {
                direction: 'horizontal',
                longSwipes: false,
                preventInteractionOnTransition: true,
              })
            } else {
              this.listSwiper = new Swiper('.list-swiper-container', {
                direction: 'horizontal',
                autoHeight: true,
                preventInteractionOnTransition: true,
                threshold: 50,
              })
            }
            this.listSwiper.on('slideChangeTransitionStart', () => {
              const index = this.listSwiper.activeIndex
              this.tabSwiper.slideTo(index)
              this.isInTransition = true
              window.scrollTo(0, 0)
            })
            this.listSwiper.on('slideChangeTransitionEnd', () => {
              const index = this.listSwiper.activeIndex
              this.showCount = 10
              this.selectedIndex = index
              this.count = this.tabResultData.shop[index].COUNT
              this.subSelect = 0
              this.searchResult = this.tabResultData.shop[index].fc
              this.$nextTick(() => {
                this.listSwiper.updateAutoHeight(100)
                setTimeout(() => {
                  this.isInTransition = false
                }, 100)
              })
            })
          })
        })
        .catch(() => {})
    },
    requestDataBySub(code) {  // kego-todo
      this.$store.dispatch('layout/startLoading')
      this.afterInit = false
      this.searchResult = []
      this.count = 0
      var params = {}
      params.session_id = this.$store.state.auth.sessionId
      params.type = '1'
   // params.LIMIT = 300

   // サブジャンル選択時、FC優待施設データ取得API呼び出し
      params.SEARCH_TAG_ID = this.searchTagId
      params.GENRE = code

      var formData = new FormData();
      for (var k in params) {
        formData.append(k, params[k] ?? "");
      }

      this.$.post(API_SHOP_LIST_FC, formData)
        .then((response) => {
          this.afterInit = true
          this.$store.dispatch('layout/startLoading')
          this.count = response.data.COUNT
          for (var i in response.data.fc) {
            response.data.fc[i].on = false
            response.data.fc[i].accordion = false
          }
          this.searchResult = response.data.fc
          this.$nextTick(() => {
            this.listSwiper.updateAutoHeight(100)
          })
          this.$store.dispatch('layout/endLoading')
        })
        .catch(() => {
          this.afterInit = true
        })
    },
    combineUrl(url) {
      return url
        ? this.$store.getters['env/apiBase'] +
            '/images/ph' +
            (Array(9 - url.length).join('0') + url).substring(-9 + url.length) +
            '.jpg'
        : noImg
    },
    accordionSwitch(item, index) {
      // 高さを設定する準備
      var contentName = 'contents_accrdion_' + this.selectedIndex + '_' + index
      var listSet = document
        .getElementById(contentName)
        .getElementsByClassName('one_set')
      var contentsHeight = 0
      for (var i = 0; i < listSet.length; i++) {
        contentsHeight = contentsHeight + listSet[i].offsetHeight
      }
      // +下部閉じるボタン
      var bottomButton = document
        .getElementById(contentName)
        .getElementsByClassName('switch')
      contentsHeight = contentsHeight + 2 * bottomButton[0].offsetHeight

      if (!item.accordion) {
        item.accordion = true
      } else {
        item.accordion = false
      }

      if (item.accordion) {
        // モーダルを開く
        if (!this.isMobile) {
          this.groupModalWindowFlg = true
        }
        // 全てのアコーディオン高さをリセット
        for (
          var i = 0;
          i < document.querySelectorAll('.type_multi .contents').length;
          i++
        ) {
          document.querySelectorAll('.type_multi .contents')[
            i
          ].style.maxHeight = ''
        }
        // リセット後開くアコーディオンの高さを設定
        document.getElementById(contentName).style.maxHeight =
          contentsHeight + 'px'
      } else {
        // モーダルを閉じる
        this.groupModalWindowFlg = false
        // 全てのアコーディオン高さをリセット
        for (
          var i = 0;
          i < document.querySelectorAll('.type_multi .contents').length;
          i++
        ) {
          document.querySelectorAll('.type_multi .contents')[
            i
          ].style.maxHeight = ''
        }
      }
    },
    openAccordion(index) {
      const contentName =
        'contents_accrdion_' + this.selectedIndex + '_' + index
      var listSet = document
        .getElementById(contentName)
        .getElementsByClassName('one_set')
      var contentsHeight = 0
      for (var i = 0; i < listSet.length; i++) {
        contentsHeight = contentsHeight + listSet[i].offsetHeight
      }
      // +下部閉じるボタン
      var bottomButton = document
        .getElementById(contentName)
        .getElementsByClassName('switch')
      document
        .getElementById(contentName)
        .style.setProperty('-webkit-transition', '0s')
      contentsHeight = contentsHeight + 2 * bottomButton[0].offsetHeight
      document.getElementById(contentName).style.maxHeight =
        contentsHeight + 'px'
      this.$nextTick(() => {
        document
          .getElementById(contentName)
          .style.setProperty('-webkit-transition', '0.5s ease')
      })
    },
    saveSessAndToDetail(shopId,member_onley_flag) {
     if (shopId) {
        if (!this.$store.state.auth.loggedIn && member_onley_flag === '1') {
          setSessionItem('PRE_SCREEN_ID', 'SU-07-03')
          this.$popup({
            text: '施設の詳細を表示するにはログインを行ってください。',
            url: this.$route.path,
            loginurl: this.facilityUrl(shopId),
          })
        } else {
          if (this.groupModalWindowFlg) {
            this.groupModalClose(!this.isMobile)
          }
          if (!this.isMobile) {
            console.log(window.scrollY)
            this.$store.dispatch('searchResult/changeScrollTop', window.scrollY)
          } else {
            const scrollEls = document.getElementsByClassName(
              'list-swiper-slide'
            )
            this.$store.dispatch(
              'searchResult/changeScrollTop',
              scrollEls[this.selectedIndex].scrollTop
            )
          }
          setSessionItem('PRE_SCREEN_ID', 'SU-07-03')
          this.$router.push({
          name: 'facility-detail',
          params: { id: shopId },
          })
        }
      } else {
        if (this.count == 0) {
          return
        }

        this.groupModalClose()

        if (this.isOnline) {
          this.$popup({
            text: 'オンライン優待は検索結果一覧のみとなります。',
          })
          return
        }

        const filteredResult = this.filterObject(
          this.searchResult,
          (val, key) => {
            return val.shop[0].WEB_FLAG != 1
          }
        )
        const mapShops = {
          COUNT: this.count,
          fc: filteredResult,
        }
        const shops = {
          COUNT: this.count,
          fc: this.searchResult,
        }
        setSessionItem('SHOP', JSON.stringify(shops))
        setSessionItem('MAP_SHOP', JSON.stringify(mapShops))
        setSessionItem('TYPE', '1')
        this.$store.dispatch('layout/disableMapAlive')
        removeSessionItem('index')
        setSessionItem('PRE_SCREEN_ID', 'SU-05')
        window.dataLayer.push({
          event: 'Webview',
          ap_screen_name: 'JAFナビ_検索一覧_地図で見る表示',
        })
        toMapWithQuery()
      }
    },
    compCSS(item) {
      return [
        this.$style.shop_detail,
        this.$style.accordion,
        item.on ? this.$style.on : '',
      ]
    },
    changeData(shopData) {
      var shop = JSON.parse(shopData).shop
      var changeData = []
      var shops = []
      var fc = {}
      for (var i = 0; i < Object.keys(shop).length; i++) {
        shops = []
        shops.push(shop[i])
        fc = {
          FC_FLAG: '0',
          FC_NO: '',
          FC_NAME: '',
          FC_IMAGE: '',
          shop: shops,
        }
        changeData.push(fc)
      }

      this.searchResult = changeData
    },
    setGroupCount(item) {
      var count = 0
      for (var i = 0; i < this.oneSlectItem.length; i++) {
        if (this.oneSlectItem[i].id == item.id) {
          count++
        }
      }
      return count
    },
    pcModalOpen(item, index) {

      this.selectedShop = item
      this.tempSelectedShop = item

      // モーダルを開く
      this.groupModalWindowFlg = true

      // モーダルが開いたら、bodyにfixedを付与
      this.windowScrollY = window.scrollY
      document.body.style.position = 'fixed'
      document.body.style.width = '100%'
      document.body.style.top = '-' + this.windowScrollY + 'px'
    },
    modalHeightSet() {
      // 画面高さ
      var wh = window.innerHeight
      var groupModalId = document.getElementById('group_popup')
      var headObj = groupModalId.getElementsByClassName('modal_head')
      var headH = headObj[0].offsetHeight
      var max = Math.floor(wh * 0.8 - headH)
      groupModalId.getElementsByClassName('modal_inner')[0].style.maxHeight =
        max - 20 + 'px'
    },
    initTabIndex() {
      this.selectedIndex = 0
      this.subSelect = 0
    },
    getSubList(index) {
      if (this.tabs.length == 0) {
        return []
      }
      const currentTab = this.tabs[index]
      return subGenreListByCode(currentTab.TAB_ID)
    },
    resetSubData() {
      const index = this.selectedIndex

      if (!this.tabResultData || !this.tabResultData.shop) {
        return
      }

      for (var i in this.tabResultData.shop[index].fc) {
        this.tabResultData.shop[index].fc[i].on = false
        this.tabResultData.shop[index].fc[i].accordion = false
      }

      this.searchResult = this.tabResultData.shop[index].fc
      this.count = this.tabResultData.shop[index].COUNT

      this.$nextTick(() => {
        this.listSwiper.updateAutoHeight(100)
      })
    },
    tabSelected(index) {
      this.selectedIndex = index
      this.subSelect = 0
      this.resetSubData()
      this.showCount = 10

      if (this.listSwiper) {
        this.listSwiper.slideTo(index)
      }
    },
    groupModalClose(param) {
      // モーダルが閉じられ時...
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      window.scrollTo(0, this.windowScrollY)

      // モーダルを閉じる
      this.groupModalWindowFlg = false
      // 全てのアコーディオン高さをリセット

      this.selectedShop = null
      if (param !== true) {
        this.tempSelectedShop = null
      }

      for (
        var i = 0;
        i < document.querySelectorAll('.type_multi .contents').length;
        i++
      ) {
        document.querySelectorAll('.type_multi .contents')[i].style.maxHeight =
          ''
      }
    },
    stopEvent() {
      event.stopPropagation()
    },
    clearToTop() {
      this.$store.dispatch('facilitySearch/setDisplayMode', DISPLAYMODE.START)
      clearSessionSearch()
      this.$router.push({
        name: 'facility-search',
        params: { clear: true },
      })
    },
    partTabSearchResult(index) {
      if (this.selectedIndex == index && this.subSelect != 0) {
        return this.searchResult
      }
      if (
        this.tabResultData &&
        this.tabResultData.shop &&
        this.tabResultData.shop[index]
      ) {
        const result = {}
        let key

        for (key in this.tabResultData.shop[index].fc) {
          if (
            this.tabResultData.shop[index].fc.hasOwnProperty(key) &&
            key < this.showCount
          ) {
            result[key] = this.tabResultData.shop[index].fc[key]
          }
        }

        return result
      }
    },
    tabSearchResult(index) {
      if (this.selectedIndex == index && this.subSelect != 0) {
        return this.searchResult
      }
      if (
        this.tabResultData &&
        this.tabResultData.shop &&
        this.tabResultData.shop[index]
      ) {
        return this.tabResultData.shop[index].fc
      }
    },
    tabCount(index) {
      if (this.selectedIndex == index && this.subSelect != 0) {
        return this.count
      }

      return this.tabResultData.shop[index].COUNT
    },
    shouldShowTabList(index) {
      if (
        !this.afterInit ||
        (this.tabSearchResult(index) &&
          Object.keys(this.tabSearchResult(index)).length > 0)
      ) {
        if (index == this.selectedIndex) {
          return true
        }
        return false
      } else {
        return false
      }
    },
    filterObject(obj, callback) {
      return Object.fromEntries(
        Object.entries(obj).filter(([key, val]) => callback(val, key))
      )
    },
    isShowOnlineItem(item) {
      if (
        this.areaCode && this.areaCode != ''
      ) {
        return item.shop[0].WEB_FLAG != 1
      }

      return true
    },
    onScroll() {
        var usersHeading = this.$refs[`shop_info_${this.selectedIndex}`]
        if (usersHeading) {
          var bottom = usersHeading[0].getBoundingClientRect().bottom
          var innerHeight = window.innerHeight

          if (bottom - innerHeight < 100) {
            console.log('load')
            this.showCount += 10
            this.$nextTick(() => {
              this.listSwiper.updateAutoHeight(10)
            })
          }
        }
    },
    facilityUrl(shopId) {
        var url = `${process.env.VUE_APP_SSO_URL}?qServiceId=${
        process.env.VUE_APP_SSO_ID
      }&qUrl=${encodeURIComponent(
        decodeURI(`https://${location.host}/facility-detail/${shopId}`)
      )}`
      return url
    },
    discount(facility) {
      var discount = ''
      if (facility.WB_NAIYO1) {
        discount = discount + facility.WB_NAIYO1
      }
      if (facility.WB_HANNI1) {
        discount = discount + facility.WB_HANNI1
      }
      var GAKURITU = '' + facility.WB_GAKURITU1
      if (facility.WB_NAIYO1) {
        var gakuritsu = facility.WB_GAKURITU1
        if (facility.WB_TANIKU1 === '1') {
          // 割引単位区分が1(％)だった場合
          if (!gakuritsu.match('/.*引.*/')) {
            // 割引額に「引」が含まれていない場合
            if (!gakuritsu.match('/.*%.*/')) {
              // 割引額に「％」が含まれていない場合
              // 割引額に「％割引」を付与
              GAKURITU = facility.WB_GAKURITU1 + '％割引'
            } else {
              // 割引額に「％」が含まれていた場合
              // 割引額に「引き」を付与
              GAKURITU = facility.WB_GAKURITU1 + '割引'
            }
          }
        }
        if (facility.WB_TANIKU1 === '2') {
          // 割引単位区分が1(％)だった場合
          if (!gakuritsu.match('/.*引.*/')) {
            // 割引額に「引」が含まれていない場合
            if (!gakuritsu.match('/.*円.*/')) {
              // 割引額に「％」が含まれていない場合
              // 割引額に「％割引」を付与
              GAKURITU = facility.WB_GAKURITU1 + '円引'
            } else {
              // 割引額に「％」が含まれていた場合
              // 割引額に「引き」を付与
              GAKURITU = facility.WB_GAKURITU1 + '引'
            }
          }
        }
      }
      return discount + GAKURITU
    },
  },
  filters: {
    truncate: function(value, length, omission) {
      var length = length ? parseInt(length, 10) : 20
      var ommision = omission ? omission.toString() : '...'

      if (value.length <= length) {
        return value
      }

      return value.substring(0, length) + ommision
    },
  },
}
</script>

<style lang="scss" src="@assets/css/SU-07.scss" scoped></style>
<style lang="scss" src="@assets/css/searchTag-facility.scss" scoped></style>

<style lang="scss">
@import '@assets/css/su_common.scss';
.hide {
  display: none !important;
}
</style>
